import { render } from "./PayPassword.vue?vue&type=template&id=677f710c&scoped=true"
import script from "./PayPassword.vue?vue&type=script&lang=js"
export * from "./PayPassword.vue?vue&type=script&lang=js"

import "./PayPassword.vue?vue&type=style&index=0&id=677f710c&lang=scss&scoped=true"
import "./PayPassword.vue?vue&type=style&index=1&id=677f710c&lang=scss"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677f710c"]])

export default __exports__